/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState } from 'react'

interface SectionContextProps {
  section: string
  setSection: (section: string) => void
  stockSection: string
  setStockSection: React.Dispatch<React.SetStateAction<string>>
  accessesSection: string
  setAccessesSection: React.Dispatch<React.SetStateAction<string>>
  certificatesSection: string
  setCertificatesSection: React.Dispatch<React.SetStateAction<string>>
  productionFlowSection: string
  setProductionFlowSection: React.Dispatch<React.SetStateAction<string>>
  refreshSection: boolean
  setRefreshSection: React.Dispatch<React.SetStateAction<boolean>>
  routerSection: string
  setRouterSection: React.Dispatch<React.SetStateAction<string>>
  permissions: string[]
}

const SectionContext = createContext<SectionContextProps>({
  section: '',
  setSection: () => {},
  stockSection: '',
  setStockSection: () => {},
  accessesSection: '',
  setAccessesSection: () => {},
  certificatesSection: '',
  setCertificatesSection: () => {},
  productionFlowSection: '',
  setProductionFlowSection: () => {},
  refreshSection: false,
  setRefreshSection: () => {},
  routerSection: '',
  setRouterSection: () => {},
  permissions: []
})

export default SectionContext

export const SectionProvider: React.FC<any> = ({ children }) => {
  const [section, setSection] = useState<string>('orders')
  const [stockSection, setStockSection] = useState<string>('stock')
  const [accessesSection, setAccessesSection] = useState<string>('accesses')
  const [certificatesSection, setCertificatesSection] = useState<string>('certificates')
  const [routerSection, setRouterSection] = useState<string>('freight')
  const [permissions] = useState<string[]>([])
  const [productionFlowSection, setProductionFlowSection] = useState<string>('services')
  const [refreshSection, setRefreshSection] = useState<boolean>(false)

  return (
    <SectionContext.Provider
      value={{
        section,
        setSection,
        stockSection,
        setStockSection,
        accessesSection,
        setAccessesSection,
        certificatesSection,
        setCertificatesSection,
        routerSection,
        setRouterSection,
        productionFlowSection,
        setProductionFlowSection,
        refreshSection,
        setRefreshSection,
        permissions,
      }}
    >
      {children}
    </SectionContext.Provider>
  )
}
